/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Kundert } from './images/kundert'
import { Hauri } from './images/hauri'
import { Deuschle } from './images/deuschle'
import { Trachsel } from './images/trachsel'
import { Born } from './images/born'
import { SvgBlinker } from '../svgblinker'
import { Link } from '@ta-interaktiv/contentbricks'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

// TODO Set the correct article ID here
const ARTICLE_ID = '593189258763'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>«Wir sind Durchbrüchler und waren sehr überrascht»</h1>
            <h2>
              Durchbruchsinfektionen nehmen in der Schweiz zu, meistens sind sie
              mild, Long-Covid könnte aber ein Problem bleiben. Betroffene
              erzählen, wie sie den Krankheitsverlauf erlebten. Braucht es bald
              Booster?
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Marc Brupbacher, Mathias Lutz</div>
            <div className='ta updated'>Aktualisiert am 2. September 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Vollständig gegen Corona geimpft und trotzdem infiziert: Die Zahl
              solcher Fälle steigt auch in der Schweiz und verunsichert viele
              Menschen. Vorneweg: Der Schutz vor akuter schwerer Erkrankung ist
              nach wie vor sehr hoch. Dennoch sind die vielen Ansteckungen unter
              Geimpften nicht unproblematisch.
            </p>
            <div className='hint' style={{ marginBottom: '1em' }}>
              <p>
                Die *markierten Namen wurden zwecks Anonymisierung abgeändert,
                das Alter und die Angabe des Kantons sind jedoch korrekt.
              </p>
            </div>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Deuschle />} />
            </div>
            <p className='names'>
              <span className='mark'>«</span>Es lief wohl dank der Impfung so{' '}
              <nobr>glimpflich ab</nobr>
              <span className='mark'>»</span>
            </p>
            <div className='info'>
              Florian Deuschle, 32
              <br />
              Kanton Thurgau
            </div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              <span className='mark'>«</span>Als Arzt in einem Schweizer Spital
              war ich privilegiert, dass ich die zweite Dosis Pfizer/Biontech
              bereits Anfang März erhielt. Dennoch bin ich vor kurzem an Covid
              erkrankt, vermutlich hat mich trotz Schutzmassnahmen ein schwer
              kranker Patient angesteckt. Die Symptome kamen wie angeworfen mit
              Heiserkeit, trockenem Husten, Temperatur sowie Hals- und
              Kopfschmerzen. Der PCR-Test war positiv. Ich machte sieben Tage
              später zu Hause noch einen Selbsttest, der war immer noch positiv,
              was nahelegt, dass doch eine gewisse Viruslast und vermutlich
              Infektiosität bestand. In den zehn Tagen Krankheit plagten mich
              auch Muskel- und Gelenkschmerzen, eine laufende Nase, Geruchs- und
              Geschmacksverlust und Schwindel. Heute fühle ich mich abgesehen
              von etwas Husten und einer leichten Geruchsminderung wieder
              genesen, leistungsmässig fühle ich mich nicht eingeschränkt. Ich
              hoffe, dass ich nicht später noch Long Covid bekomme. Ich denke,
              dass die Impfung dazu beigetragen hat, dass es so glimpflich
              ablief. Natürlich hätte ich lieber gar keine Infektion gehabt.
              Klar wurde mir: Wir Immunisierten sollten uns wohl doch nicht zu
              sicher fühlen.<span className='mark'>»</span>
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Als erstes Land schlug Israel Alarm, nachdem es fünf Monate lang
              als Impf-Weltmeister vollständige Freiheit mit wenigen
              Corona-Fällen genossen hatte. Es häuften sich die Meldungen zu
              Impfdurchbrüchen. Zurzeit weist das Land eine der höchsten
              Fall-Inzidenzen weltweit auf. Am Mittwoch wurde mit über 11’100
              Fällen ein neuer Höchststand erreicht, mehr als die Hälfte davon
              war geimpft. Im Juni wurde beim Pfizer/Biontech-Vakzin ein
              Impfschutz von nur noch 41% vor symptomatischer Erkrankung{' '}
              <Link href='https://www.gov.il/BlobFolder/reports/vaccine-efficacy-safety-follow-up-committee/he/files_publications_corona_two-dose-vaccination-data.pdf'>
                ermittelt
              </Link>{' '}
              – ursprünglich waren es über 95% gewesen. Bei jenen, die bereits
              im Januar geimpft wurden, betrug der Schutz sogar lediglich noch
              16%. Die Unterschiede zwischen den Altersklassen waren gering.
            </p>
            <p>
              Viele Experten zweifelten damals an den Daten des
              Gesundheitsministeriums. Mittlerweile gibt es aber über ein
              Dutzend Preprints und Studien aus aller Welt, die eine stark
              sinkende Immunität nach vier bis sechs Monaten feststellten (
              <Link href='https://www.nejm.org/doi/full/10.1056/NEJMc2112981?query=featured_home'>
                hier
              </Link>
              ,{' '}
              <Link href='https://www.cdc.gov/mmwr/volumes/70/wr/mm7034e4.htm'>
                hier
              </Link>
              ,{' '}
              <Link herf='https://www.reuters.com/business/healthcare-pharmaceuticals/british-study-shows-covid-19-vaccine-efficacy-wanes-under-delta-2021-08-18/'>
                hier
              </Link>{' '}
              und{' '}
              <Link href='https://www.medrxiv.org/content/10.1101/2021.08.25.21262584v1'>
                hier
              </Link>
              ). In{' '}
              <Link href='https://www.medrxiv.org/content/10.1101/2021.08.06.21261707v2.full'>
                Minnesota
              </Link>{' '}
              wurde eine Reduktion des Impfschutzes vor Infektion zwischen
              Februar und Juli von 91% auf 76% bei Moderna gemessen und von 89%
              auf 42% bei Pfizer/Biontech, in{' '}
              <Link href='https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3909743'>
                Kalifornien
              </Link>{' '}
              gab es einen Rückgang in vier Monaten von 93% auf 53% (ebenfalls
              Pfizer/Biontech). In{' '}
              <Link href='https://www.medrxiv.org/content/10.1101/2021.08.11.21261885v1'>
                Qatar
              </Link>{' '}
              boten zuletzt zwei Dosen von Pfizer/Biontech noch 60% Schutz vor
              einer Delta-Infektion, bei Moderna waren es 86%.
            </p>
            <p>
              Dass der Impfstoff von Moderna wohl{' '}
              <Link href='590854565586'>etwas besser</Link> und länger schützt
              und mehr Antikörper produziert, hat sich im Laufe der Zeit{' '}
              <Link href='https://jamanetwork.com/journals/jama/fullarticle/2783797'>
                erhärtet
              </Link>
              . Dennoch empfiehlt auch Moderna, noch vor dem Winter die
              Auffrischungsimpfung zu verabreichen.
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Kundert />} />
            </div>
            <p className='names'>
              <span className='mark'>«</span>
              Der Krankheitsverlauf ist hartnäckiger, als{' '}
              <nobr>ich vermutete</nobr>
              <span className='mark'>»</span>
            </p>
            <div className='info'>
              Lea Kundert*, 56
              <br />
              Kanton Zürich
            </div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              <span className='mark'>«</span>
              Leider ist es auch bei mir vor rund zwei Wochen zu einer
              Durchbruchsinfektion gekommen, obwohl ich seit Ende Mai geimpft
              bin. Damit hätte ich nicht gerechnet. Mein 17-jähriger Sohn hat
              das Virus aus seinen Ferien in Kroatien mitgebracht. Der
              Krankheitsverlauf ist hartnäckiger, als ich vermutet habe. Zu
              Beginn waren da Kopfschmerzen, gelegentlich musste ich niesen.
              Dazu kamen ein trockener Husten mit leichten Schmerzen auf den
              Bronchien, ein stark fiebriges Gefühl ohne Fieber und ausgeprägter
              Nachtschweiss. Auch litt ich an Schwindel und
              Konzentrationsproblemen. Der Geruchs- und Geschmackssinn war
              ebenfalls gestört und ist es bis heute. Übrigens auch bei meinem
              Sohn, der die Krankheit wie eine Grippe erlebte, in zwei Wochen
              aber vier Kilogramm abnahm. Abgesehen davon, fühlt er sich nun
              wieder gesund. Ich selber bin immer noch müde und der Appetit
              fehlt, mir geht es aber jeden Tag etwas besser. Trotz allem bin
              ich dankbar, dass es mich nur mild erwischt hat, hatten wir doch
              in der Familie jemanden mit einem schweren Verlauf, der fast
              gestorben wäre.<span className='mark'>»</span>
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              All diese Studien stellten zwar einen relativ kurzlebigen
              Impfschutz vor einer Infektion und symptomatischer Erkrankung,
              aber einen anhaltend hohen vor schwerer Erkrankung,
              Spitaleinweisung oder Tod fest. Wie von Immunologen erwartet,
              schwindet der Antikörperspiegel schneller als die längerfristige
              und zelluläre Immunität mittels T- und B-Zellen.
            </p>
            <p>
              Aber auch diese zweite Abwehr lässt irgendwann nach, vor allem bei
              älteren Personen, wie eine{' '}
              <Link href='https://www.medrxiv.org/content/10.1101/2021.08.26.21262468v1'>
                Studie der Berliner Charité
              </Link>{' '}
              ergab. Bei vier von zehn Personen mit dem Durchschnittsalter 82
              waren nach einem halben Jahr keine neutralisierenden Antikörper
              mehr gegen die Delta-Variante feststellbar. Bei der Gruppe, die im
              Durchschnitt 35 Jahre alt war, hatten immer noch über 97 Prozent
              neutralisierende Antikörper. Ein signifikanter Unterschied zeigte
              sich auch in der T-Zell-Antwort. «Insgesamt deuten diese
              Ergebnisse darauf hin, dass das etablierte Zwei-Dosen-Impfschema
              bei älteren Menschen im Vergleich zu jungen Erwachsenen weniger
              dauerhafte Immunreaktionen hervorruft», heisst es im Preprint.
            </p>
            <p>
              In Israel, das weltweit seine Bevölkerung am frühesten impfte und
              deshalb als Kanarienvogel in der Mine gilt,{' '}
              <Link href='https://www.gov.il/BlobFolder/reports/vaccine-efficacy-safety-follow-up-committee/he/files_publications_corona_immunity-waning-082021.pdf'>
                sank mit der Zeit
              </Link>{' '}
              auch der Schutz vor schwerer Erkrankung bei
              Pfizer-Vollimuniserten. Eine Studie der{' '}
              <Link href='https://www.timesofisrael.com/israels-severe-covid-cases-could-reach-400-by-mid-august-researchers-warn/'>
                Hebrew University of Jerusalem
              </Link>{' '}
              zeigte Ende Juli, dass die Effektivität von über 95% auf 80% fiel.
              Das mag zwar immer noch als hoch erscheinen, ist aber doch ein
              grosser Unterschied: 95% Schutzwirkung bedeutet eine Reduktion des
              Risikos, schwer zu erkranken, um das 20-Fache, 80% stellt nur noch
              ein fünfmal geringeres Risiko dar.
            </p>
            <p>
              Dies zeigt sich auch in den Spitälern in Israel, die zunehmend an
              ihre Belastungsgrenzen kamen: 65% der Hospitalisierten sind dort
              mittlerweile geimpft. Seit Anfang Juni erkrankten über 1500
              Personen schwer und 400 starben trotz zwei Dosen mRNA-Impfstoff.
              Das sind bedeutende Zahlen, auch wenn sie ohne Vakzine das
              Zehnfache betragen würden und das Gesundheitssystem längst
              kollabiert wäre.
            </p>
            <p>
              Die Daten veranlassten Israel, seiner Bevölkerung seit Anfang
              August die dritte Impfdosis anzubieten. Über 70% der über
              70-Jährigen haben bereits eine Auffrischung erhalten. Mittlerweile
              können sich schon alle ab 12 Jahren boosten lassen. Personen, die
              sich nicht dreimal impfen lassen, gelten ab sofort offiziell nicht
              mehr als geimpft.
            </p>
            <p>
              Die Wirkung blieb nicht aus: Rund zwei Wochen nach dem Start der
              Booster-Kampagne stieg in dieser Sommerwelle erstmals die Zahl der
              schwer kranken Geimpften im Spital nicht mehr weiter an.
            </p>
            <div className='chart'>
              <AutofitIFrame
                src='//datawrapper.dwcdn.net/fWlJU/'
                style={{ height: '580px' }}
              />
            </div>
            <p>
              <Link href='https://www.gov.il/BlobFolder/reports/vaccine-efficacy-safety-follow-up-committee/he/files_publications_corona_booster-27082021.pdf'>
                Israelische Wissenschaftler
              </Link>{' '}
              ermittelten ein fünf- bis zehnfach vermindertes Risiko, nach dem
              Booster schwer an Covid zu erkranken, im Vergleich zu nur zwei
              Dosen. Das{' '}
              <Link href='https://www.timesofisrael.com/covid-booster-shots-raise-protection-against-severe-illness-to-97-tv/'>
                Gesundheitsministerium
              </Link>{' '}
              errechnete eine Impfwirksamkeit nach dem Booster von über 95%,
              sowohl gegen eine Infektion als auch gegen eine schwere
              Erkrankung. Eine{' '}
              <Link href='https://world.einnews.com/article/549153619/zoHas9H1JkqDTIaX'>
                andere Studie
              </Link>{' '}
              des Gesundheitsdienstleisters Maccabi kam auf eine Schutzwirkung
              von 86% gegen Infektion.
            </p>{' '}
            <p>
              Damit ist man wieder auf dem ursprünglichen Effektivitätslevel von
              Anfang Jahr angelangt. Die Impfstoffe beweisen also erneut ihre
              ungeheure Wirksamkeit, auch gegen Delta. Das zeigt, dass für die
              vielen Impfdurchbrüche in den vergangenen Monaten zu einem grossen
              Teil die schnell zurückgehende Zahl an Antikörpern verantwortlich
              war, und nur zu einem kleineren Teil die Virusvariante Delta mit
              ihren immunevasiven Eigenschaften.
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker twoPerson illu={<Trachsel />} />
            </div>
            <p className='names'>
              <span className='mark'>«</span>
              Nach vier Tagen <nobr>war es vorbei</nobr>
              <span className='mark'>»</span>
            </p>
            <div className='info'>
              Manuela und Pascal Trachsel*, <nobr>46 und 50</nobr>
              <br />
              Kanton Graubünden
            </div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              <span className='mark'>«</span>
              Wir waren beide überrascht: Mein Partner und ich haben uns Ende
              Juli mit Delta infiziert, obwohl wir seit Frühling geimpft waren.
              Vermutlich hat mich Pascal angesteckt, er selber wurde
              höchstwahrscheinlich von einem ungeimpften Kollegen infiziert, der
              anschliessend wegen Covid ins künstliche Koma versetzt werden
              musste. Bei uns selber war der Krankheitsverlauf mild:
              Gliederschmerzen, Kopfschmerzen, Müdigkeit. Nach vier Tagen war es
              vorbei. Heute geht es uns gut, wir haben keine spürbaren
              Nachwirkungen. Seltsam empfanden wir, dass ich nach dem positiven
              Test von Pascal vom Contact-Tracing als Geimpfte ohne Symptome
              keine Einschränkungen verordnet bekam, es entsprach den
              Richtlinien, ich hätte überall hingehen können und hätte mich
              nicht testen lassen müssen. Ich habe dann aus Eigeninitiative doch
              einen Selbsttest gemacht, der war positiv.
              <span className='mark'>»</span>
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Obwohl in Israel erst mit der Booster-Kampagne die steigende Zahl
              der schwer erkrankten Geimpften gebremst wurde, will man in der
              Schweiz abwarten mit der Auffrischung. Das kann gefährlich werden,
              da Hunderttausende Personen der verwundbarsten Bevölkerung bald
              auch die sechs Monate seit der zweiten Dosis überschreiten und die
              Immunität zunehmend schwindet. Die meisten davon sind mit
              Pfizer/Biontech geimpft.
            </p>
            <p>
              Das BAG schreibt dazu: ​​«Zum heutigen Zeitpunkt ist aus den
              verfügbaren wissenschaftlichen Daten nicht klar, wann für wen eine
              Auffrischimpfung nötig wäre.» Viele Länder sehen das anders und
              haben bereits mit den Auffrischungen begonnen oder stehen kurz
              davor. Auch{' '}
              <Link href='https://www.theguardian.com/world/2021/aug/30/covid-booster-jabs-not-a-luxury-and-protect-the-vulnerable-says-who'>
                die WHO
              </Link>{' '}
              rät nun nicht mehr von Booster-Impfungen ab, sondern sagt, dass
              sie eine gute Möglichkeit seien, die Verwundbarsten zu schützen.
              Die in der Schweiz eingesetzten mRNA-Impfstoffe sind derzeit nur
              für 2 Impfdosen ohne Auffrischimpfung zugelassen.
            </p>
            <p>
              In der Schweiz, wo zwei Drittel mit Moderna geimpft sind und die
              Impfkampagne erst sehr spät ist Rollen kam, ist der Impfschutz vor
              schwerer Krankheit immer noch sehr hoch. Die Daten in Israel
              zeigten aber bis Anfang Juli ein ähnlich stabiles Bild.
            </p>
            <div className='chart'>
              <AutofitIFrame
                src='https://interaktiv.tagesanzeiger.ch/2021/embed-covid-spitaleintritte-nach-impfstatus/'
                style={{ height: '640px' }}
              />
            </div>
            <p>
              Aber auch hier infizieren sich gemäss Daten des BAG mittlerweile
              jede Woche Hunderte Geimpfte (Woche 33: 266). In Wahrheit sind es
              deutlich mehr, da die Zahlen zu Impfdurchbrüchen, die keinen
              Spitalaufenthalt oder einen Arztbesuch erfordern, in der Schweiz
              nicht zentral und systematisch erfasst werden, die Daten also eine
              «beträchtliche Unterschätzung» sind, wie das BAG mitteilt. Dabei
              wäre die Zahl der Impfdurchbrüche ein wichtiges Mass, um
              festzustellen, wie effektiv die Impfungen tatsächlich noch
              schützten.
            </p>
            <p>
              Mehrere Personen erzählten uns, wie sie die Impfdurchbrüche
              erlebten. Bei den meisten verlief die akute Erkrankung mild. Mit
              einer harmlosen Erkältung ist sie jedoch nicht gleichzusetzen, wie
              auch unser Beispiel von Lea Kundert zeigt. Die 56-jährige
              Zürcherin beschreibt es so: «Der Krankheitsverlauf ist
              hartnäckiger, als ich vermutet habe. Mein Geruchs- und
              Geschmackssinn ist immer noch gestört.»
            </p>
            <p>
              Erstaunlich auch: Wie oft innerhalb eines Haushalts jeweils gleich
              alle Geimpften erkranken und Vollimunisierte sich auch gegenseitig
              anstecken. Untersuchungen haben gezeigt, dass die Viruslast bei
              Geimpften und Ungeimpften nach einer Infektion zu Beginn{' '}
              <Link href='https://www.cdc.gov/mmwr/volumes/70/wr/mm7031e2.htm?s_cid=mm7031e2_w'>
                ähnlich hoch
              </Link>{' '}
              ist, bei Geimpften{' '}
              <Link href='https://www.medrxiv.org/content/10.1101/2021.07.28.21261295v1.full.pdf'>
                jedoch schneller abfällt
              </Link>
              . Daten aus den Niederlanden zeigen, dass Geimpfte, trotz
              ähnlicher Viruslasten, eine niedrigere Wahrscheinlichkeit haben
              infektiöse Viren in sich zu tragen. Es ist davon auszugehen, dass
              Geimpfte das Virus unwissentlich übertragen können wenn auch
              weniger häufig.
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker twoPerson illu={<Hauri />} />
            </div>
            <p className='names'>
              <span className='mark'>«</span>
              Vor Corona wäre ich mit diesen Symptomen zur{' '}
              <nobr>Arbeit gegangen</nobr>
              <span className='mark'>»</span>
            </p>
            <div className='info'>
              Peter und Isabel Hauri*, <nobr>74 und 73</nobr>
              <br />
              Basel-Landschaft
            </div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              <span className='mark'>«</span>Wir sind Durchbrüchler und waren
              darüber sehr überrascht. Meine Frau und ich sind seit Mai
              vollständig geimpft. Wir befolgen die Regeln zur Vermeidung einer
              Ansteckung eigentlich ziemlich penibel. Mit den Lockerungen hat
              man sich wieder getroffen, vor allem draussen, aber immer mit
              Vorsicht. Vor rund zwei Wochen, nach einem Probenwochenende im
              Dorfchor, fühlten wir uns müde und schlapp. Zudem fühlte ich mich
              auch ein wenig fiebrig. Die Heiserkeit verband ich natürlich mit
              der anstrengenden Probe. Am Montag war das Fieber zwar wieder weg,
              die Heiserkeit und ein Reizhusten wurden aber stärker. Am Abend
              machten wir beide einen Schnelltest, beide waren positiv.
              PCR-Tests bestätigten den Befund. Alle anstehenden Chorproben
              wurden abgesagt und die 22 Mitglieder informiert, die meisten sind
              auch dort geimpft. Nach vier Tagen waren meine Frau und ich
              praktisch wieder beschwerdefrei. Vor Corona wären solche Symptomen
              kaum ein Grund gewesen, nicht zur Arbeit zu gehen. Diesmal sind
              wir einfach nur froh, dass alles so mild abgelaufen ist und wir
              auch nicht zu Superspreadern wurden, im Chor gibt es bisher nur
              einen weiteren Verdachtsfall, ich denke, das ist nur der Impfung
              zu verdanken. Die grosse Frage bleibt aber: Wo in aller Welt haben
              wir uns angesteckt?<span className='mark'>»</span>
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Eine offene Frage ist zudem, wie oft es nach
              Durchbruchsinfektionen zu lang anhaltenden Beschwerden kommt.
              Bisher gibt es erst wenige Daten zu Long-Covid bei Geimpften,
              diese sind aber alles andere als erbaulich. «Auch geimpfte
              Personen können an Long-Covid erkranken»,{' '}
              <Link href='https://twitter.com/VirusesImmunity/status/1415091425298063368?s=20'>
                sagte Akiko Iwasaki
              </Link>
              , Immunologie-Professorin an der Yale-Universität, schon im Juli.
              Diese Aussage wurde zuletzt durch eine israelischen Studie
              gestützt, die im{' '}
              <Link href='https://www.nejm.org/doi/full/10.1056/NEJMoa2109072'>
                «New England Journal of Medicine»
              </Link>{' '}
              publiziert wurde. Von 1497 Pflegekräften kam es bei 39 zu
              Durchbruchsinfektionen mit der noch etwas harmloseren
              Alpha-Variante. Niemand musste ins Spital, die akute Erkrankung
              verlief bei allen mild oder moderat. Aber 19% litten auch noch
              sechs Wochen später an teilweiser schwerer Fatigue, Husten,
              Geruchs- und Geschmacksverlust oder Muskel- und Kopfschmerzen.
            </p>
            <p>
              «Falls das die Konsequenzen bei allen milden
              Durchbruchsinfektionen sein sollten, ist es wirklich
              beunruhigend», sagt Gili Regev-Yochay, Autorin der Studie,
              gegenüber{' '}
              <Link href='https://www.npr.org/sections/health-shots/2021/07/28/1021888033/breakthrough-infections-may-cause-long-covid-symptoms-small-study-suggests'>
                National Public Radio
              </Link>
              . Eric Topol, Professor für Molekularmedizin am Scripps Research
              Institute in La Jolla, Kalifornien, bewertet es so: «Wir hatten
              gehofft, dass durch die Impfung eine ausreichende Immunreaktion
              eintritt, um Long-Covid zu verhindern. Diese Studie ist die erste,
              die uns einen Hinweis darauf gibt, dass womöglich doch nicht alle
              Geimpften davor geschützt sind.»
            </p>
            <p>
              Eine{' '}
              <Link href='https://www.sciencedaily.com/releases/2021/09/210901191407.htm'>
                weitere Untersuchung
              </Link>{' '}
              aus Grossbritannien fand heraus, dass Geimpfte 47 Prozent weniger
              häufig an Long-Covid erkranken, sollten sie sich dennoch mit
              Sars-2 infizieren. Gemäss bisherigen Erkenntnissen zur Häufigkeit
              würde es also statt 10 bis 30 von 100 Erkrankten noch 5 bis 15 pro
              100 betreffen, was immer noch ein beträchtlicher Anteil ist und
              gemäss medizinischen Kriterien alles andere als selten.
            </p>
            <p>
              Christian Münz, Leiter der Immunologie-Expertengruppe der
              Schweizer Covid-19-Taskforce, hält Durchbruchsinfektionen dennoch
              für unproblematisch, ja sogar{' '}
              <Link href='764094370213'>für eine gute Sache</Link>. Damit lasse
              sich das Immunsystem natürlich boosten.
            </p>
            <p>
              Neurowissenschaftler Dominique de Quervain, ehemaliges Mitglied
              der Taskforce, beurteilt es anders: «Dieses Argument mag aus
              immunologischer Perspektive sinnvoll sein, ignoriert aber mögliche
              negative Konsequenzen einer Durchbruchsinfektion. Gerade für junge
              Leute, die an der Schule oder an der Uni sind, dürften lang
              anhaltende Müdigkeit und Konzentrationsschwierigkeiten
              problematisch sein. Noch ist die Datenlage dünn. Gerade deshalb
              sollte aber das Vorsorgeprinzip gelten. Vor einer Infektion trotz
              Impfung rate ich dringend ab.»
            </p>
            <p>
              «Ich glaube, wir sollten vorsichtig sein», meint auch die Genfer
              Virologin Isabella Eckerle. «Prinzipiell stimmt es, dass bei den
              normalen Erkältungsviren eine immer wieder stattfindende Infektion
              die Immunität stärkt. Wir sollten aber keine direkten Schlüsse von
              endemischen Erkältungs-Coronaviren, die genetisch recht stabil
              sind, auf Sars-CoV-2 ziehen, das laufend neue Varianten aufweist.»
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker twoPerson illu={<Born />} />
            </div>
            <p className='names'>
              <span className='mark'>«</span>
              Vermutlich hat der Enkel das Virus aus der Schule mitgebracht
              <span className='mark'>»</span>
            </p>
            <div className='info'>
              Maria und Peter Born*, <nobr>75 und 95</nobr>
              <br />
              Kanton Solothurn
            </div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              <span className='mark'>«</span>
              Wir wohnen mit unserer Tochter und ihren zwei Buben im selben
              Haus. Wir sind vor zehn Tagen alle fünf an Covid erkrankt, obschon
              die Tochter und wir seit Februar bzw. März geimpft sind!
              Vermutlich hat der achtjährige Enkel das Virus aus der Schule mit
              nach Hause gebracht. Er verlor die Stimme und hatte sehr hohes
              Fieber, bis zu 40 Grad, zudem plagte ihn zwei Tage lang ein
              heftiger, schmerzhafter Husten. Das Fieber liess nach einer Woche
              nach. Sein jüngerer Bruder hatte einen ähnlichen Verlauf. Wir
              Erwachsenen hatten folgende Symptome: verschleimter Husten, eine
              Woche lang immer wieder leichtes Fieber und starke Müdigkeit. Mein
              Mann und ich sind stark vorbelastet. Auch heute haben wir immer
              mal noch Mühe mit Atmen bei Anstrengungen, sind aber ansonsten
              schmerzfrei. Die Müdigkeit kommt und geht. Uns allen geht es schon
              besser, aber ganz fit sind wir noch nicht.
              <span className='mark'>»</span>
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text & Recherche', 'Marc Brupbacher'],
          ['Umsetzung', 'Mathias Lutz']
        ]}
      />
    </div>
  )
}
